export {
    isColor,
    isArrayOfColors,
    sanitizeArrayOfColors,
} from '@splunk/visualization-encoding/utils/colorUtils';
